export function hasConsentExtensionEmailData(period?: number | null): boolean {
  return typeof period === 'number' && period >= 0;
}
